import { VerticalTabs } from "../../../components";
import RaReports from "./AtsTabs/RaReports";
import BdmReports from "./AtsTabs/BdmReports";
import React, { useState } from "react";
// import Workforce from "./Workforce";
import { useModuleAccess } from "../../../hooks";
import RecruiterReports from "./AtsTabs/RecruiterReports";
import EmailReports from "./AtsTabs/EmailReport";
import ReportsTable from "./ReportsTable";

const Ats = ({isFavourite}) => {
  const [selectedReport, setSelectedReport] = useState(null);
  const [activeTab, setActiveTab] = useState("RA Report");

  const tabs = [
    { title: "RA Report", id: "reports_ats_rareport", type: "RA" },
    { title: "BDM Report", id: "reports_ats_bdmreport", type: "BDM" },
    { title: "Recruitment Report", id: "reports_ats_recruitmentreport", type: "RECRUITER" },
    { title: "Email Report", id: "reports_ats_emailreport", type: "EMAIL" }
  ];

  const tabList = tabs.map((tab) => {
    return {
      title: tab?.title,
      id: tab?.id,
      page: (
        <div className="flex-1 p-2 flex flex-col">
          <ReportsTable
            type={tab?.type}
            selectedReport={activeTab === tab?.type ? selectedReport : null}
            isFavourite={isFavourite}
            setSelectedReport={(val) => {
              setActiveTab(tab?.title);
              setSelectedReport(val);
            }}
          />
        </div>
      ),
    }
  })
  const filteredTabs = useModuleAccess({
    allTabs: tabList,
    parentId: "reports_ats",
  });

  if (selectedReport) {
    if (activeTab === "RA Report") {
      return (
        <RaReports
          selectedReport={selectedReport}
          setSelectedReport={setSelectedReport}
        />
      );
    }

    if (activeTab === "BDM Report") {
      return (
        <BdmReports
          selectedReport={selectedReport}
          setSelectedReport={setSelectedReport}
        />
      );
    }

    if (activeTab === "Recruitment Report") {
      return (
        <RecruiterReports
          selectedReport={selectedReport}
          setSelectedReport={setSelectedReport}
        />
      );
    }

    if (activeTab === "Email Report") {
      return (
        <EmailReports
          selectedReport={selectedReport}
          setSelectedReport={setSelectedReport}
        />
      )
    }
  }

  const activeTabIndex = filteredTabs.findIndex(tab => tab.title === activeTab);

  return (
    <div className="my-2">
      <VerticalTabs
        tabs={filteredTabs}
        defaultTab={activeTabIndex >= 0 ? activeTabIndex : 0}
        activeColor="primary"
        activeVariant="contained"
        onTabChange={(item) => setActiveTab(item?.title)}
      />
    </div>
  );
};

export default Ats;
